import React, { useContext, useEffect, useState } from 'react';
import ASaleGroup from '../components/a-sale-group';
import { SaleItemsContext } from '../index';
const SaleList = () => {
    const [saleItemsState] = useContext(SaleItemsContext);
    const [filteredSaleOrder, setFilteredSaleOrder] = useState([]);
    useEffect(() => {
        if (saleItemsState && saleItemsState.saleOrder) {
            // ステータスが開催前のセールを除外する
            /*setFilteredSaleOrder(() =>
              saleItemsState.saleOrder.reduce((acc: t.SaleProp[], saleProp: t.SaleProp) => {
                if (saleProp.sale_status !== 0) {
                  acc.push(saleProp)
                }
                return acc
              }, [])
            )*/
            setFilteredSaleOrder(saleItemsState.saleOrder);
        }
    }, [
        saleItemsState
    ]);
    return (React.createElement(ASaleGroup, { saleOrder: filteredSaleOrder }));
};
export default SaleList;
